module.exports = __webpack_public_path__ + "static/EmberColour-abc618045a8564ac2ea4ec45a3320f31.svg";